<span *ngIf="enable && validationMessage" class="text-danger">
	{{ validationMessage }}
</span>
